<ngb-alert *ngIf="type === 'warning'" [type]="type" [dismissible]="false">
  Your individual user plan expires in less than one month - {{ expirationDate | date: 'MM/dd/yyyy' }},
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options. </a>
  <span class="justify-content-end default-pointer" title="Close" aria-label="Close" id="closeBannerBtn" (click)="closeBanner()">
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
      <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="#856404"
        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
      />
    </svg>
  </span>
</ngb-alert>
<ngb-alert *ngIf="type === 'danger'" [type]="type" [dismissible]="false">
  Your individual user plan has expired. Public projects are still available,
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options. </a>
  <span class="justify-content-end default-pointer" title="Close" aria-label="Close" id="closeBannerBtn" (click)="closeBanner()">
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
      <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="#856404"
        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
      />
    </svg>
  </span>
</ngb-alert>
<ngb-alert *ngIf="type === 'custom'" [type]="'warning'" [dismissible]="false">
  Your individual user plan has technically expired and you are in a 7 day grace period,
  <a href="https://www.terminologyhub.com/plans" target="_blank">click here for options. </a>
  <span class="justify-content-end default-pointer" title="Close" aria-label="Close" id="closeBannerBtn" (click)="closeBanner()">
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
      <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="#856404"
        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
      />
    </svg>
  </span>
</ngb-alert>
<ngb-alert *ngIf="type === 'expiredwithorg'" [type]="'warning'" [dismissible]="false">
  Your individual user plan is expired but connected to an active organization plan.
  <span class="justify-content-end default-pointer" title="Close" aria-label="Close" id="closeBannerBtn" (click)="closeBanner()">
    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
      <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        fill="#856404"
        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
      />
    </svg>
  </span>
</ngb-alert>
